import { CheckCircle, Circle } from '@mui/icons-material';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { TaskEntity } from '@/types/api';

export interface TaskStatusChipProps {
  status: TaskEntity['status'];
  size?: 'small' | 'medium';
}

export const TaskStatusChip = ({ status, size = 'small' }: TaskStatusChipProps) => {
  const { t } = useTranslation();

  return (
    <Chip
      label={t(`tasks.status.${status}`)}
      color={status === 'open' ? 'warning' : 'default'}
      size={size}
      icon={status === 'open' ? <Circle /> : <CheckCircle />}
    />
  );
};
